import {
  AdjustmentsHorizontalIcon, ArrowUpTrayIcon, BanknotesIcon, BuildingOffice2Icon, CalendarDaysIcon, UsersIcon,
} from '@heroicons/react/24/outline'

/** Ikona każdego kroku samouczka (`lib/samouczek/kroki.js`), ta sama w oknie powitania i w panelu. */
const IKONY = {
  firma: BuildingOffice2Icon,
  klienci: ArrowUpTrayIcon,
  zespol: UsersIcon,
  kalendarz: CalendarDaysIcon,
  cennik: BanknotesIcon,
  sprzet: AdjustmentsHorizontalIcon,
}

export const ikonaKroku = (klucz) => IKONY[klucz] || BuildingOffice2Icon
